import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, watch } from "vue";
import Modal2Component from "@/components/modal/Modal2Component.vue";
import { showErrorMessage } from "@/services/ui/messages";
import { useSubCompaniesStore } from "@/pinia/subcompanies/subcompanies";
import { minLength, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

interface FormModel {
  name: string;
  data?: {
    ebkId?: number;
  };
}

interface Props {
  value: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateSubCompanyFormModal',
  props: {
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean;
}




function emitUpdateValue(newValue: boolean) {
  emit("input", newValue);
}

const isPending = ref(false);
const formModel = reactive<FormModel>({
  name: "",
  data: {
    ebkId: null,
  },
});
const rules: { [key in keyof FormModel]?: any } = {
  name: { required, minLength: minLength(3) },
};
const v = useVuelidate(rules, formModel);

function validateState(field: { $dirty: boolean; $invalid: boolean }) {
  const { $dirty, $invalid } = field;
  return $dirty ? !$invalid : null;
}

watch(
  () => props.value,
  () => {
    resetFormModel();
    v.value.$reset();
  }
);

async function handleSubmit() {
  try {
    const isValid = await v.value.$validate();
    if (!isValid) return;

    isPending.value = true;
    await useSubCompaniesStore().createSubCompany(formModel);
    emitUpdateValue(false);
    await useSubCompaniesStore().fetchSubCompanies();
  } catch (e) {
    showErrorMessage(e);
  } finally {
    isPending.value = false;
  }
}

function resetFormModel() {
  formModel.name = "";
}

return { __sfc: true,props, emit, emitUpdateValue, isPending, formModel, rules, v, validateState, handleSubmit, resetFormModel, Modal2Component }
}

})